"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceQualificationClient = void 0;
const tslib_1 = require("tslib");
class ServiceQualificationClient {
    constructor(client, formatter) {
        this.client = client;
        this.formatter = formatter;
    }
    /**
     * Get autocomplete address results.
     *
     * @throws HttpError
     *
     * @param address
     * @returns
     */
    autocomplete(address) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const geographicAddresses = yield this.client.geographicAddress(address);
            const formattedAddresses = this.formatter.formatAddresses(geographicAddresses);
            return formattedAddresses;
        });
    }
    /**
     * Get a service qualification for an address string.
     *
     * @throws HttpError
     *
     * @param carrier
     * @param id
     * @returns
     */
    sqText(address) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const geographicAddress = {
                '@type': 'UnitiGeographicAddress',
                address: address,
                identifiers: [],
                geographicSubAddress: []
            };
            const serviceQualificationQuery = yield this.client.serviceQualificationQuery(geographicAddress);
            const formattedServiceQualifications = this.formatter.formatServiceQualificationItems(serviceQualificationQuery);
            return (formattedServiceQualifications.length) ? formattedServiceQualifications : [];
        });
    }
    /**
     * Get a service qualification for a carrier and id.
     *
     * @throws HttpError
     *
     * @param carrier
     * @param id
     * @returns
     */
    sqCarrier(carrier, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const geographicAddress = {
                '@type': 'UnitiGeographicAddress',
                identifiers: [
                    {
                        type: 'carrier',
                        name: carrier,
                        value: id
                    }
                ],
                geographicSubAddress: []
            };
            const serviceQualificationQuery = yield this.client.serviceQualificationQuery(geographicAddress);
            const formattedServiceQualifications = this.formatter.formatServiceQualificationItems(serviceQualificationQuery);
            return (formattedServiceQualifications.length) ? formattedServiceQualifications[0] : undefined;
        });
    }
    /**
     *
     * Gets an already completed service qualification by ID.
     *
     * @throws HttpError
     *
     * @param id The UUID for an existing serviceQualificationQuery result
     */
    getSq(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const serviceQualificationQuery = yield this.client.loadServiceQualificationQuery(id);
            const formattedServiceQualifications = this.formatter.formatServiceQualificationItems(serviceQualificationQuery);
            return (formattedServiceQualifications.length) ? formattedServiceQualifications : [];
        });
    }
    /**
     * Get a service qualification for an address object.
     *
     * @throws HttpError
     *
     * @param address
     * @returns
     */
    sqAddress(address) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const geographicAddress = {
                '@type': 'UnitiGeographicAddress',
                identifiers: address.identifiers,
                geographicSubAddress: []
            };
            const serviceQualificationQuery = yield this.client.serviceQualificationQuery(geographicAddress);
            const formattedServiceQualifications = this.formatter.formatServiceQualificationItems(serviceQualificationQuery);
            return (formattedServiceQualifications.length) ? formattedServiceQualifications : [];
        });
    }
}
exports.ServiceQualificationClient = ServiceQualificationClient;
//# sourceMappingURL=serviceQualificationClient.js.map